<template>
	<TagGroupForm
		:tag-group="tagGroup"
		:is-saving="isSaving"
		:title="transUcfirst('tag_group.edit')"
		@save="save"
		@close="close"
	/>
</template>

<script>
import { mapActions } from 'vuex';
import TagGroupForm from '@videotools/js/analysis/components/TagGroups/TagGroupForm';
import TagGroup from '@videotools/js/api/entities/TagGroup';

export default {
	name:       'EditTagGroup',
	components: { TagGroupForm },
	props:      {
		tagGroup: {
			type:     TagGroup,
			required: true,
		},
	},
	data() {
		return {
			isSaving: false,
		};
	},
	methods: {
		...mapActions({
			update:              'tagGroups/update',
			updateCustomButtons: 'tagGroups/updateCustomButtons',
		}),
		async save(data) {
			this.isSaving = true;
			try {
				const { customButtons, ...tagGroupData } = data;
				await this.update({
					tagGroupId:    this.tagGroup.id,
					tagGroupData:  tagGroupData,
					customButtons: customButtons,
				});

				this.close();
			} finally {
				this.isSaving = false;
			}
		},
		close() {
			this.$emit('close');
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
